module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2n"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("1.")])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('h2', {
    staticClass: "h2t"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("The Zodiac")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "word5"
  }, [_vm._v("MIDDLE SCHOOL IS HARD.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Solving cases for the "), _c('span', {
    staticClass: "allcaps"
  }, [_vm._v("FBI")]), _vm._v(" is even harder.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Doing both at the same time, well, that’s just crazy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Trust me, I know. My name’s Florian Bates, I’m twelve years old, and along with my best friend, Margaret, I’m a consulting detective for the Bureau’s Special Projects Team. We assist the "), _c('span', {
    staticClass: "allcaps"
  }, [_vm._v("FBI")]), _vm._v(", the same way Sherlock Holmes helped Scotland Yard; only Sherlock never had to close a case "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("and")]), _vm._v(" write a book report on the same night.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("He also didn’t have to deal with all the other seventh-grade headaches like locker room bullies, nine o’clock curfews, or figuring out what to wear. All he had to do ")]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("was put on his coat and deerstalker hat. Instant detective.")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Me? It seems like I’m always dressed for the wrong occasion. Like when we had to interrogate a witness while I was still in my soccer uniform. Or the time I was wearing my "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("I’M WITH CHEWBACCA")]), _vm._v(" T-shirt and we ended up going undercover at the reception for the French ambassador. (In case you’re wondering, “"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Que la Force soit avec toi")]), _vm._v("” is how you say “May the Force be with you” in French.)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So when we arrived at the harbor patrol’s maintenance-and-repair yard it shouldn’t have been a surprise that I was the only one wearing a double-breasted blazer and herringbone tie. My mistake was that when I dressed for the symphony, I forgot to factor in the possibility of racing down the Potomac in a police boat. (I know, you’d think I’d learn.)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The boat was Marcus’s idea. He oversees the Special Projects Team and it was a good plan except for one little detail: None of us actually had access to a boat. That meant we had to borrow one.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Margaret and I waited outside the harbormaster’s office while he went in to see if he could get the duty sergeant to help us out. The stench of diesel was overwhelming, engine grease was everywhere, and when I saw my reflection in the window, I noticed my tie was crooked.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("“What are you doing?” Margaret asked when she saw me fidget with it.")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Trying to straighten the knot,” I explained. “It’s a Windsor. It’s supposed to be perfectly centered.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She gave me a look. That Margaret “you’ve got to be kidding me” look. “We’re standing on a wharf surrounded by gas and grime and you’re worried about your tie being crooked. Why don’t you try to relax? No one’s going to notice.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Technically it’s not a wharf,” I corrected. “We’re standing on a "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("dock")]), _vm._v(". And the dock is part of a "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("marina")]), _vm._v(". A wharf is an entirely different thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Seriously?” she replied, shaking her head. “That’s your takeaway from what I just said? Correcting my vocabulary?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I gave her a sheepish smile and apologized. Then I tried to follow her advice and relax. But it wasn’t easy. I’m not that good at relaxing on a normal day when nothing’s going on, and this was no normal day. We were baffled by a missing persons case that was on the verge of making headlines across the world.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("That morning we’d boarded a school bus for a field trip to the Kennedy Center for the Performing Arts. At the time, our biggest worry was finding a seat just the right distance from the bullies in back and the chaperones in front. Then ")]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("one of our classmates disappeared into thin air. That might have been okay if it had been a magic show, but like I said, we were there for the symphony. So it was bad. And if the press found out, it would get even worse.")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Suddenly bullies and chaperones didn’t seem like such a big deal. We had a case to solve and we weren’t having much luck figuring it out. Each clue seemed to lead us further away from the answer. And now, on top of that, I had an additional obstacle to overcome.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Can I be honest with you?” I asked Margaret.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This far into the friendship and you don’t know?” she said. “You can always be honest with me. In fact, that’s all you can be.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That made me smile.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay, so here’s the deal,” I replied. “I’m not exactly "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("comfortable")]), _vm._v(" when it comes to boats.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She gave me a curious look. “What does ‘not exactly comfortable’ mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They terrify me,” I admitted. “They have ever since I saw that movie about the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Titanic")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know it’s at least eighty degrees today,” she said. “I’m pretty sure we’re not going to run into any icebergs.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not worried about sinking,” I explained. “It’s just that I got . . . seasick.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("“You got seasick "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("watching")]), _vm._v(" a movie?”")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I nodded reluctantly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Were you at least on a boat while you were watching it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No. We were home. I’ll skip the vivid details, but we ended up having to rent one of those industrial-sized steam cleaners for the carpet and couch.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My thoughts wafted back to the salami sandwich and jalapeño-flavored tortilla chips that began the day in my lunch bag, and I wondered if they would soon be reintroduced to the world.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, you might not have to worry about it,” Margaret said, looking through the window into the office. “I think Marcus is striking out in there.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even though we weren’t inside, it wasn’t hard to guess what the problem was. The harbor patrol was part of the Metropolitan Police Department, and Marcus was with the "), _c('span', {
    staticClass: "allcaps"
  }, [_vm._v("FBI")]), _vm._v(". Those two groups are very protective of their turf and almost never work well together.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Think we should help out?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She asked it like a question, but considering she didn’t wait for me to answer before she opened the door and went inside, I didn’t really have much of a chance to say no.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("The sergeant was big with ruddy skin, chubby cheeks, and a mustache that looked like it belonged on a walrus. He ")]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("stood behind a counter similar to the check-in desk at a hotel and looked as though his patience was gone.")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“But this is an emergency,” Marcus said, frustrated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You keep saying that,” replied the cop. “But I haven’t heard a thing about it on my radio.” He nodded to the police scanner on his desk.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s because we’re trying to keep it contained to the "), _c('span', {
    staticClass: "allcaps"
  }, [_vm._v("FBI")]), _vm._v(" and Secret Service,” answered Marcus. “We haven’t involved the local police yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The sergeant flashed a smug smile. “There, you just said it yourself. You don’t want to involve the local police. Well, unfortunately for you, these boats belong to the local police. So have a nice day.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Despite my dread of seasickness, I knew we needed the boat, so I tried to help out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What if Frankie was missing?” I asked, interrupting. “You’d want us to look for him, wouldn’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The sergeant turned his attention to me and shot me with a laser stare.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Or imagine your daughter, Maddie, went camping with her Girl Scout troop and got lost in a national park.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How do you know about my kids?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("I ignored his question. “How would you feel if the park rangers wouldn’t help the police who were trying to rescue ")]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("her because they were from different agencies? How would you feel if they did to you what you’re doing to us right now?”")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("By this point he was really angry, his fat cheeks turning crimson. “I said, how do you know about my kids?” he demanded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The nameplate on your desk says you’re Frank Bergen Sr.,” I explained. “That means there’s a junior. I know you call him Frankie because that’s how he signed the drawing you taped to the window over there. I know your daughter Maddie’s in Girl Scouts because you’ve got five cases of Girl Scout cookies marked ‘Maddie B.’ stacked behind your desk so you can deliver them to your coworkers.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He started to say something, but I just kept talking.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know your kids at all, but I know you’re the kind of dad who tapes his son’s pictures up at work and tries to help his daughter sell cookies. It’s the best kind of dad to be. That’s why I know that eventually you’re going to give Agent Rivers the keys to a boat so we can try to rescue my friend. I just don’t know if you’re going to do it soon enough for us to make a difference.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("For a moment the room was silent except for the sound of the sergeant taking a deep breath while he considered what I’d said. His nostrils flared as he inhaled and he studied ")]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("me for a moment before begrudgingly slapping a set of keys down onto the counter.")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“If there’s so much as a scratch . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There won’t be,” Marcus said as he snatched them up. “You’re a good cop, Frank. And a good father. Thank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just do me a favor and find the kid,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That we will,” Marcus said as he grabbed a pair of dingy orange life vests from a rack and handed them to us. “That we will.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We followed Marcus outside and had to hurry to keep up. “That was great work in there, Florian,” he said, taking quick long strides. “Our boat’s at the end of the dock.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I looked out at the water and felt a wave of uneasiness. “We’re sure this is the best way to go, right?” I asked, hoping it sounded more like a question of strategy than a fear of barfing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, for two reasons,” he said. “First of all, it’s our only chance to get close to the bridge without anyone noticing us.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This was the part he hadn’t mentioned to the police officer—or anyone in the Bureau, for that matter. The "), _c('span', {
    staticClass: "allcaps"
  }, [_vm._v("FBI")]), _vm._v(" and Secret Service were on the case, but we weren’t. A Child Abduction Rapid Deployment ("), _c('span', {
    staticClass: "allcaps"
  }, [_vm._v("CARD")]), _vm._v(") team was in charge and they didn’t want any help from us.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Our problem was that we were pretty sure they had it wrong.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("“Secondly, they’re going to put the bridge under surveillance and check all the roads and sidewalks leading to it,” he said. “So they’ll have everything fully covered up there. But I don’t think they’ll be checking the river traffic, and if you’re right, that’s where we need to be.”")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I gulped, realizing my theory had set this little adventure into motion, and wrestled my way into the life vest. The boat didn’t have one of those clever names like "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Oh, Say Can You Sea")]), _vm._v(" or "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("When You Fish Upon a Star")]), _vm._v(". Instead, it was just called "), _c('span', {
    staticClass: "txit"
  }, [_c('span', {
    staticClass: "allcaps"
  }, [_vm._v("MPDC-4")])]), _vm._v(". But what it lacked in creativity, it made up for in stability. I was relieved by how solid it felt beneath my feet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know, this isn’t so bad,” I said as I plopped down on a thickly padded seat. “It’s actually kind of comfy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Too bad it’s not ours.” Marcus chuckled. “We’re taking the Zodiac.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The what-iac?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The Zodiac,” he repeated. “It’s the boat tied to the back of this one.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know,” Margaret added as she pulled me back up by my life jacket and turned me toward a small inflatable tied to "), _c('span', {
    staticClass: "txit"
  }, [_c('span', {
    staticClass: "allcaps"
  }, [_vm._v("MPDC-4")])]), _vm._v(". “The teeny-tiny one.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("Up until that point the only zodiac I knew was the collection of astrological signs like Capricorn and Aquarius. But apparently it was also the name of the world’s most terrifyingly ")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("inadequate water vessel. My horoscope: rough seas ahead.")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Shouldn’t we take one of the ones with, you know, sides?” (I was no longer concerned with sounding scared.)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Remember the part about us trying not to attract attention?” Marcus said. “If the "), _c('span', {
    staticClass: "allcaps"
  }, [_vm._v("CARD")]), _vm._v(" team sees a boat with police markings invade their crime scene they’ll go nuts. This one’s completely unmarked. Besides, it’s a whole lot faster.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So you’re telling me it’s supersmall "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("and")]), _vm._v(" superfast?” I said, trying to force a smile. “That’s just . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Super?” joked Margaret.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I started to climb down into the Zodiac, but Marcus took me by the shoulders and stopped me. “You don’t have to go, Florian. I mean it. You can stay right here and I’ll have someone give you a ride home. In fact, it might be a good idea for both of you to stay. Even without the markings, there’s a decent chance they’ll spot us. And if they do there’s no telling what kind of trouble there’ll be for encroaching on someone else’s case. Especially a case so big.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("“No way,” I answered. “We have to solve this case fast. The second the press finds out, the whole situation will explode and our job will be much harder. Besides, that’s not just anyone who’s missing—it’s someone I consider a friend. I’m going to follow the clues wherever they lead. Even if it ")]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("means I have to take a submarine or ride in a helicopter.”")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Me too,” said Margaret. “Besides, if any one of us is getting in trouble, then all of us are.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He didn’t say it but I could tell he was happy with our responses. We were in every way a team.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Once we were on board, Marcus untied the boat, maneuvered it out onto the river, and opened the throttle to full speed. As we raced toward the Key Bridge, the wind made it so my tie flapped in the air and kept slapping me in the face. I was too busy double clutching the safety rope that ran along our seat to do anything about it, so Margaret leaned over and tucked the tie into my life vest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You okay?” she asked, her voice barely audible over the whine of the engine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I almost answered, but stopped when I realized that I wasn’t sure if words or lunch would come out. Instead I just nodded and gripped the rope tighter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Look for anything suspicious,” Marcus shouted so we could hear him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You mean more suspicious than the three of us?” Margaret responded.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("There was so much mist spraying my face, I had to close my eyes as I tried to picture the crime scene in my head. A thirteen-year-old had disappeared despite being surrounded by dozens ")]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("of people. There were no signs of foul play, no signs of anything out of the ordinary. The only clue we found was a sticky note with three words written in pen: "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HELP KEY BRIDGE")]), _vm._v(".")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The boat slowed down and I opened my eyes to see the Francis Scott Key Bridge come into view. Spanning the Potomac between Washington and Rosslyn, Virginia, it looked much bigger from the river than it did from the land. Whenever we drove over it in our car, it just seemed like a road that happened to pass over water. There were no towers or cables holding it up. But from this vantage point, you could see the six massive arches supporting it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Marcus continued to slow the engine until we were basically floating along with the current. He turned on his walkie-talkie and clicked through the channels until he heard some agents communicating up above.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They’re up there,” he said. “Let’s hope they won’t notice us.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What are we looking for?” asked Margaret.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Anything suspicious,” he replied. “On the water or along the riverside.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He nodded to the jogging-and-bike path that ran along the water.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("We saw a couple of kayaks and a man riding a stand-up paddleboard, but none of them was suspicious. A pair of sightseeing cruisers approached. One was named the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("General Washington")]), _vm._v(" and the other the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("President Jefferson")]), _vm._v(". Both were ")]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("decorated with red, white, and blue banners, as well as signs that advertised "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("STAR-SPANGLED TOURS.")])])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I scanned the decks of the first one but saw only tourists taking pictures. When it passed us, our boat started bobbing up and down in its wake and my stomach gurgled even more. I closed my eyes and tried not to give the second boat a show. (Imagine dozens of tourists snapping pictures as I puked over the edge of the Zodiac.) I focused all my mental energy on my stomach, trying to calm the storm inside me. Trying to ignore the motion and my sense of uselessness. Trying to block out everything.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And that’s when I noticed the music playing over the speakers on the boat. My mind was so busy concentrating on my seasickness that my subconscious brain was free to identify that something was out of place.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I looked up at Marcus and Margaret and asked, “Why’s a sightseeing boat in the capital of the United States and named after an American president playing the British national anthem?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They both gave me a confused look.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What are you talking about?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I worried I might be hallucinating. “Don’t you hear the song?”")])]), _c('p', {
    staticClass: "indentb"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("They listened for a moment and Margaret began to sing along:")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("My country, ’tis of thee,")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Sweet land of liberty,")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Of thee I sing.")])]), _vm._v(" "), _c('p', {
    staticClass: "indentab"
  }, [_vm._v("“No, no, no,” I said. “Those aren’t the lyrics. The song is ‘God Save the Queen.’ ” Having grown up in Europe, including three years spent in England, I was quite familiar with it. I started to sing the version that I knew:")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("God save our gracious Queen!")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Long live our noble Queen!")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("God save the Queen!")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Marcus smiled when he realized why I was confused. “I forgot that they both have the same tune,” he said. “The Americans kept the music and wrote new lyrics to give it a completely different meaning.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("I don’t know if it was the dizziness, my stomach, the case, the clues, the music, or all of it. But in that moment I felt a surge moving up through my body. I couldn’t tell if I was going to get sick, if my head was going to explode, or if I ")]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("was going to solve the mystery right then and there. It just bubbled up through me. And then . . .")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I need to get off the boat,” I said urgently.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s the matter?” asked Marcus. “Are you going to get sick?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” I answered, my nausea instantly cured by my realization. “I told you I’d follow the clues wherever they lead, and they’re not in the water.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How do you know?” asked Margaret.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s complicated,” I replied. “But the first thing you have to understand is that ‘God Save the Queen’ changes everything.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c62556b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 66
// module chunks = 0